import React, { FC } from 'react';
import { Option } from '~/types/products';
import { Sweetener, SweetenerKeys } from '~/types/products';

import InfoCircle from '../../../Icons/outline/InfoCircle';
import Tooltip from '../../../Tooltip';
import setHtml from '~/helpers/setHtml';
import LegalAnnotation from '~/components/LegalAnnotation';
import { LegalMap } from '~/types/legal';

export interface Props {
  legalMap: LegalMap;
  sweetener: Option;
  is200: boolean;
  is500: boolean;
  is1Gig: boolean;
  is2Gig: boolean;
  is5Gig: boolean;
  is7Gig: boolean;
  sweeteners: {
    [key: string]: Sweetener;
  };
}

const { VRC } = SweetenerKeys;

const PlanCardBanner: FC<Props> = ({ sweeteners, sweetener, legalMap }) => {
  const vrcSweetener = sweetener?.value === 'visa';


  return (
    <div className="plan-card__banner" data-testid="plan-card-banner">
      <div className="plan-card__banner-headline">
        {vrcSweetener && sweeteners[VRC] && (
          <>
            <span>
              <span {...setHtml(`$${sweeteners.vrc.amount} ${sweeteners.vrc.name}`)} />
              <LegalAnnotation legalKey={VRC} />
            </span>
            <Tooltip
              position="top"
              theme="light"
              html={
                <div style={{ width: 190 }}>
                  <div className="tooltip-info">
                    {legalMap?.vrcProrated?.text}
                  </div>
                </div>
              }
            >
              <InfoCircle />
            </Tooltip>
          </>
        )}
      </div>
    </div>
  );
};

PlanCardBanner.displayName = 'PlanCardBanner';

export default PlanCardBanner;
